import { Injectable, inject, signal } from '@angular/core';
import { BagUiService } from './bag-ui.service';

@Injectable({ providedIn: 'root' })
export class OverlayService {
  private readonly bagUi = inject(BagUiService);
  readonly searchOpen = signal(false);
  readonly menuOpen = signal(false);

  openCart(): void {
    this.closeSearch();
    this.closeMenu();
    this.bagUi.show();
  }

  openSearch(): void {
    this.bagUi.hide();
    this.closeMenu();
    this.searchOpen.set(true);
    document.body.classList.add('basel-search-opened');
  }

  closeSearch(): void {
    this.searchOpen.set(false);
    document.body.classList.remove('basel-search-opened');
  }

  openMenu(): void {
    this.bagUi.hide();
    this.closeSearch();
    this.menuOpen.set(true);
    document.body.classList.add('act-mobile-menu');
  }

  closeMenu(): void {
    this.menuOpen.set(false);
    document.body.classList.remove('act-mobile-menu');
  }

  closeAll(): void {
    this.bagUi.hide();
    this.closeSearch();
    this.closeMenu();
  }
}
